<template>
  <div>

      <div class="row">
        <div class="col-xs-12">
          <div class="block block-rounded">
            <div class="block block-themed">
            <div class="block-header bg-primary-dark">
                  <ul  class="block-options">
                      <li v-if="flagDisplayBundle===0">
                          <button type="button" @click="toggleDisplayBundle()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                      </li>
                      <li v-if="flagDisplayBundle">
                          <button  type="button" @click="toggleDisplayBundle()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                      </li>
                  </ul>
              <h2 class="block-title" @click="toggleDisplayBundle()"><i class="fa fa-usb fa-1x push-5-r "></i>{{actualBundle.sub_bundle[bundleIndex].bundle_name}}</h2>
            </div>

            <div v-if="flagDisplayBundle" class="block-content">

              <div class="row">
                <div class="col-xs-12">
                    <!-- Static Labels -->
                    <div class="block">
                        <div class="block-header">
                              <h1 class="page-heading">{{actualBundle.sub_bundle[bundleIndex].bundle_id}}</h1>
                        </div>
                        <div class="block-content block-content-narrow">
                              <h1 class="page-heading">{{actualBundle.sub_bundle[bundleIndex].bundle_id}}</h1>
                        </div>

                        <div class="col-sm-12 col-md-12">
                          <p><button @click="saveMyProfile()" type="button" class="btn btn-success align-right" name="button">New Button</button></p>
                        </div>

                    </div>
                    <!-- END Static Labels -->
                </div>
              </div>

            </div>
        </div>
      </div>
      </div>
    </div>
  </div>


</template>

<script>

import _ from 'underscore'
import {mapState, mapGetters} from 'vuex'

export default {
  props: ['bundleIndex'],
  data() {
    return {
      displayDataTable : false,
      flagDisplayBundle : 0,

      
      actualLanguage : "FR",
      labelTableTop: {FR: 'Afficher le tableau des données', EN: 'Display data table'},
    }
  },
  computed: {
    ...mapState('sessionStore', ['profileData','displayAdminFlag','actualBundle']),
  },
  methods: {
  
   toggleDisplayBundle(){
      this.flagDisplayBundle = ~this.flagDisplayBundle
    },

  },
  mounted() {
    //Retirer l'inversion puisque le composant PortGraph effectue l'inversion sur la variable 
    //this.tableData = this.portData.reverse();
    //this.tableData = this.portData;
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// bundle.vue?539a31d0